import { render, staticRenderFns } from "./Parcelas.vue?vue&type=template&id=6622eb87"
import script from "./Parcelas.vue?vue&type=script&lang=js"
export * from "./Parcelas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports